export default "__VITE_ASSET__CyzvZOOj__"